import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { colors } from "@dotnet/telematics-design-system";

interface ISircularLoaderWithBackdropProps {
  isLoading: boolean;
}

const CircularLoaderWithBackdrop = ({
  isLoading
}: ISircularLoaderWithBackdropProps) => {
  return (
    <Backdrop
      open={isLoading}
      sx={{
        zIndex: "9999"
      }}
    >
      <CircularProgress
        sx={{
          color: colors.white
        }}
      />
    </Backdrop>
  );
};

export default CircularLoaderWithBackdrop;
